import React from 'react';

const STATUS_STYLES = {
  cancelled: { label: 'Ακυρώθηκε', bg: '#fef2f2', text: '#b91c1c', dot: '#ef4444' },
  no_show:   { label: 'Δεν ήρθε',   bg: '#fffbeb', text: '#b45309', dot: '#f59e0b' },
  completed: { label: 'Ολοκληρώθηκε', bg: '#f0fdf4', text: '#15803d', dot: '#22c55e' },
};

const CardEvent = ({ title, timeText, borderColor = '#607d8b', viewType, start, end, status }) => {
  const [customer, service] = title.includes(' – ') ? title.split(' – ') : [title, ''];
  const durationMin = (new Date(end) - new Date(start)) / 60000;
  const isMonth = viewType === 'dayGridMonth';
  const hasEnded = new Date(end) < new Date();
  const effectiveStatus = !status && hasEnded ? 'completed' : status || '';
  const st = STATUS_STYLES[effectiveStatus];

  if (isMonth) {
    return (
      <div style={{
        height: '100%',
        borderLeft: `3px solid ${borderColor}`,
        paddingLeft: '5px',
        display: 'flex', alignItems: 'center',
        fontSize: '11px', fontWeight: 600,
        color: '#1A1A2E',
        overflow: 'hidden',
      }}>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {customer}
        </span>
      </div>
    );
  }

  return (
    <div style={{
      height: '100%',
      borderLeft: `3px solid ${borderColor}`,
      paddingLeft: '7px',
      paddingRight: '4px',
      paddingTop: '3px',
      paddingBottom: '3px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
      overflow: 'hidden',
      boxSizing: 'border-box',
    }}>
      {/* Customer name */}
      <div style={{
        fontSize: '12px', fontWeight: 700,
        color: '#1A1A2E', lineHeight: 1.2,
        overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
      }}>
        {customer}
      </div>

      {/* Time + status */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px', flexWrap: 'nowrap' }}>
        {timeText && (
          <span style={{ fontSize: '10px', color: '#888', whiteSpace: 'nowrap' }}>
            {timeText}
          </span>
        )}
        {st && (
          <span style={{
            display: 'inline-flex', alignItems: 'center', gap: '3px',
            background: st.bg, color: st.text,
            fontSize: '9px', fontWeight: 600,
            borderRadius: '20px', padding: '1px 6px',
            whiteSpace: 'nowrap', flexShrink: 0,
          }}>
            <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: st.dot }} />
            {st.label}
          </span>
        )}
      </div>

      {/* Service — only if duration ≥ 45min */}
      {service && durationMin >= 45 && (
        <div style={{
          fontSize: '10px', color: '#aaa', marginTop: '2px',
          overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
        }}>
          {service}
        </div>
      )}
    </div>
  );
};

export default CardEvent;
